import { gql } from '@apollo/client'

export const CREATE_APPLICATION_MUTATION = gql`
    mutation putApplication($request: CreateApplicationRequest) {
        putApplication(request: $request)
    }
`

